import React from 'react';
import { FormContext } from 'react-hook-form';
import { t, Trans } from '@lingui/macro';
import { isEmpty } from 'lodash';
import styled from 'styled-components/native';

import AuthenticationContainer from '@src/components/AuthenticationContainer';
import AuthenticationSendButton from '@src/components/AuthenticationSendButton';
import Image from '@src/components/Image';
import LabelInput from '@src/components/LabelInput';
import { Body1 } from '@src/components/Typography';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { padding } from '@src/configuration/constants';
import { i18n } from '@src/i18n';
import { Label } from '@src/types';

import { Props } from './types';
import useForm from './useForm';

const travellingTypePreferences: Label[] = [
  { id: 1, name: i18n._(t`Tour`) },
  { id: 2, name: i18n._(t`Alone`) },
];

const Labels1Banner: React.FC = styled(Image).attrs({
  source: require('./labels1.jpg'),
  resizeMode: 'cover',
})`
  width: 100%;
  height: 120px;
  margin-vertical: 10px;
`;

const Text = styled(Body1)`
  text-align: center;
  margin: ${padding}px 0;
`;

const Screen: React.FC<Props> = ({ navigation }) => {
  const { form, handleSubmit, loading } = useForm();

  React.useLayoutEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <AuthenticationSendButton
          loading={loading}
          disabled={loading || !isEmpty(form.errors)}
          onPress={handleSubmit}
        >
          <Trans>Next</Trans>
        </AuthenticationSendButton>
      ),
      title: '',
    });
  }, [form.errors, handleSubmit, loading, navigation]);

  return (
    <>
      <VisibleStatusBar />
      <AuthenticationContainer>
        <FormContext {...form}>
          <LabelInput
            ListHeaderComponent={
              <>
                <Text>
                  <Trans>
                    There of different types of travel packages here , even you
                    can travel to the space !
                  </Trans>
                </Text>
                <Labels1Banner />
                <Text>
                  <Trans>How do you like to travel?</Trans>
                </Text>
              </>
            }
            name="travellingTypePreference"
            labels={travellingTypePreferences}
          />
        </FormContext>
      </AuthenticationContainer>
    </>
  );
};

Screen.displayName = 'SetupTravelingPreference';

export default React.memo(Screen);
